import { useContext, useEffect, useState } from "react";
import { Box, VStack, Text, Flex, Icon } from "@chakra-ui/react";
import { FiZap, FiUsers, FiTarget } from "react-icons/fi";
import { HiClipboardDocumentList } from "react-icons/hi2";
// import { MdSubscriptions, MdOutlineContactPage } from "react-icons/md";
import { BiSolidRocket } from "react-icons/bi";
import { convertToSlug } from "../helper/helper";
import { appContext } from "../Context/AppContext";
import { TbLogout } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

const Sidebar = ({ setAction }: any) => {
  // const [selected, setSelected] = useState<any>(null);
  const navigate = useNavigate();
  const { setPageId, pageId } = useContext(appContext);

  const accessType = localStorage.getItem("logged_in_user_type") || "";
  const showAllTabs = accessType === "manoshala";
  const storedPermissions = localStorage.getItem("logged_in_user_permissions");
  const userPermissions = storedPermissions
    ? JSON.parse(storedPermissions)
    : [];

  const availableTabs = [
    { key: "hotleads", label: "HOT LEADS", title: "HOT", icon: FiZap },
    { key: "warmleads", label: "WARM LEADS", title: "WARM", icon: FiZap },
    { key: "coldleads", label: "COLD LEADS", title: "COLD", icon: FiZap },
    { key: "single", label: "SINGLE", title: "SINGLE", icon: FiUsers },
    {
      key: "subscription",
      label: "SUBSCRIPTION",
      title: "SUBS",
      icon: FiUsers,
    },
    {
      key: "leadreachout",
      label: "LEADS REACHOUT",
      title: "LR",
      icon: BiSolidRocket,
    },
    {
      key: "customerreachout",
      label: "CUSTOMER REACHOUT",
      title: "CR",
      icon: BiSolidRocket,
    },
    {
      key: "reachoutlogs",
      label: "REACHOUT LOGS",
      title: "RL",
      icon: HiClipboardDocumentList,
    },
    {
      key: "followuplogs",
      label: "FOLLOWUP LOGS",
      title: "FL",
      icon: HiClipboardDocumentList,
    },
  ];

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  const goToHomePage = () => {
    navigate("/");
  };

  useEffect(() => {
    if (!showAllTabs && !userPermissions.includes("hotleads")) {
      const nextTab: any = availableTabs.find(
        (tab) => showAllTabs || userPermissions.includes(tab.key)
      );

      if (nextTab) {
        navigate(nextTab.path);
      }
    }
  }, []);

  return (
    <Box
      bg="#70afaf"
      color="white"
      w="10%"
      h="100vh"
      p="20px 0"
      position="fixed"
    >
      <Text
        fontSize="lg"
        textAlign="center"
        justifyContent="center"
        fontWeight="bold"
        marginBottom="24px"
        onClick={() => goToHomePage()}
        cursor="pointer"
      >
        DOLPHIN
      </Text>
      <VStack align="flex-start" spacing={1}>
        {availableTabs.map((tab) => (
          <Box
            key={tab.key}
            w="100%"
            bg={
              pageId === convertToSlug(tab.label)
                ? "#f5a623"
                : showAllTabs || userPermissions.includes(tab.key)
                ? "#518585"
                : "#ccc"
            }
            p="15px 0"
            onClick={() => {
              if (showAllTabs || userPermissions.includes(tab.key)) {
                setPageId(convertToSlug(tab.label));
                setAction("");
              }
            }}
            cursor={
              showAllTabs || userPermissions.includes(tab.key)
                ? "pointer"
                : "not-allowed"
            }
            opacity={showAllTabs || userPermissions.includes(tab.key) ? 1 : 0.8}
          >
            <Flex
              align="center"
              fontSize="15px"
              paddingLeft="10px"
              gap={3}
              // color={selected === idx ? "yellow" : "white"} // Change text color for selected
            >
              <Icon as={tab.icon} boxSize={5} />
              <Text>{tab.title}</Text>
            </Flex>
          </Box>
        ))}
      </VStack>
      <Flex
        cursor="pointer"
        fontWeight="medium"
        fontSize="lg"
        onClick={handleLogout}
        color="#fff"
        direction="row"
        alignItems="center"
        gap={2}
        marginTop={5}
        marginLeft={2}
      >
        <TbLogout size="20" />
        <Text fontSize="md">Logout</Text>
      </Flex>
    </Box>
  );
};

export default Sidebar;
